export const CREATE_WPS_CONFIG_SETTING = "CREATE_WPS_CONFIG_SETTING";
export const FETCH_WPS_CONFIG_SETTINGS = "FETCH_WPS_CONFIG_SETTINGS";
export const EDIT_WPS_CONFIG_SETTING = "EDIT_WPS_CONFIG_SETTING";
